module.exports = __webpack_public_path__ + "static/media/olympic.22d7f08d.svg";